<div class="updateEmail">
        <div class="modal" #updateEmail id="saved_search_Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
            <div class="updateEmail-dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="exampleModalLabel">Update email address</h4>
                            <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-3 col-sm-3">
                                    Country
                                </div>
                                <div class="col-md-1 col-sm-1">:</div>
                                <div class="col-md-8 col-sm-8">
                                    {{countryDetails?.countryNameSelected}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 col-sm-3">
                                    Old Email
                                </div>
                                <div class="col-md-1 col-sm-1">:</div>
                                <div class="col-md-8 col-sm-8">
                                    {{countryDetails?.userEmailSelected}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 col-sm-3">
                                    New Email
                                </div>
                                <div class="col-md-1 col-sm-1">:</div>
                                <div class="col-md-8 col-sm-8">
                                    <input class="newEmail" id="userEmail" type="email" [(ngModel)]="newEmail">
                                    <div class="error" *ngIf="showError">{{errorMessage}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default editEmailSaveBtn" (click)="onSave()">SAVE </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>